var map = {
	"./employee-collage-0.avif": 87197,
	"./employee-collage-1.avif": 33253,
	"./employee-collage-2.avif": 73306,
	"./employee-collage-225w-3.avif": 54376,
	"./employee-collage-3.avif": 80854,
	"./employee-collage-335w-1.avif": 86411,
	"./employee-collage-335w-2.avif": 77898,
	"./employee-collage-336w-0.avif": 56503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99774;